<div [class.overlay]="!show" [class.active]="show" fxLayout="column" fxLayoutAlign="center center">
  <div class="message" i18n>Drop hier je bestanden!</div>
  <div><mat-icon class="icon">get_app</mat-icon></div>
</div>
